import { useEffect } from "react";
import axiosClient from "../../api/api";
import { useSearchParams } from "react-router";

const Callback = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    axiosClient
      .get(
        `/auth/spotifyCallback?code=${searchParams.get(
          "code"
        )}&state=${searchParams.get("state")}`
      )
      .then((response) => {
        if (response.status === 200) {
          localStorage.setItem("authToken", response.data.token);

          window.location.href = "/";
        }
      });
  }, [searchParams]);

  return <div></div>;
};

export default Callback;
